// @flow
import './default-bundle';

import SideMenuRouter from '@src/SideMenuRouter';
import DiamondCutProportionsCarousel from '@components/carousels/diamond_education/DiamondCutProportions';
import GradingDiamondCutCarousel from '@components/carousels/diamond_education/GradingDiamondCut';
import DiamondPolishScaleCarousel from '@components/carousels/diamond_education/DiamondPolishScale';
import DiamondSymmetryScaleCarousel from '@components/carousels/diamond_education/DiamondSymmetryScale';
import DiamondColorScaleCarousel from '@components/carousels/diamond_education/DiamondColorScale';
import DiamondClarityScaleCarousel from '@components/carousels/diamond_education/DiamondClarityScale';
import DiamondAnatomyCarousel from '@components/carousels/diamond_education/DiamondAnatomy';
import DiamondClarityCarousel from '@components/carousels/diamond_education/DiamondClarity';
import ReceivedItemsFooter from '@components/ReceivedItemsFooter';

ReactOnRails.register({
  SideMenuRouter,
  DiamondCutProportionsCarousel,
  GradingDiamondCutCarousel,
  DiamondPolishScaleCarousel,
  DiamondSymmetryScaleCarousel,
  DiamondColorScaleCarousel,
  DiamondClarityScaleCarousel,
  DiamondAnatomyCarousel,
  DiamondClarityCarousel,
  ReceivedItemsFooter
});
